import React from 'react';
import RentCalculator from './rent-calculator-mapping';

import { RentCalculatorProvider } from './context';

const RentCalculatorRoute = () => {
  return (
    <RentCalculatorProvider>
      <RentCalculator />
    </RentCalculatorProvider>
  );
};

export default RentCalculatorRoute;
